"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BamsBouncingThunderclapAbilityHandler = exports.BamsBouncingThunderclapActorAbilityFactory = exports.BamsBouncingThunderclapAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Unblockable_1 = require("../../core/effects/core/Unblockable");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
class BamsBouncingThunderclapAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BamsBouncingThunderclap;
        this.__typeName = "BamsBouncingThunderclap";
    }
}
exports.BamsBouncingThunderclapAbilityArgs = BamsBouncingThunderclapAbilityArgs;
let BamsBouncingThunderclapActorAbilityFactory = class BamsBouncingThunderclapActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BamsBouncingThunderclap", "AllEnemies", 4);
    }
};
BamsBouncingThunderclapActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BamsBouncingThunderclap")
], BamsBouncingThunderclapActorAbilityFactory);
exports.BamsBouncingThunderclapActorAbilityFactory = BamsBouncingThunderclapActorAbilityFactory;
let BamsBouncingThunderclapAbilityHandler = class BamsBouncingThunderclapAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyBuff({
            sequence,
            creatorId: ability.invokerId,
            targetId: ability.invokerId,
            duration: Duration_1.Duration.EndOfTurn,
            effect: new Unblockable_1.UnblockableEffectArgs()
        });
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        const abilityPower = Math.round(180 / (targets.length + 1));
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            targets: targets
                .map(targetId => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Sonic", abilityPower),
                    AbilityDamage_1.AbilityDamage.Power("Nature", abilityPower),
                ],
            })),
            onHitOrMiss(sequence, { targetId }, { hit }) {
                sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                    : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "ChainLightningBolt"));
            }
        });
    }
};
BamsBouncingThunderclapAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BamsBouncingThunderclap)
], BamsBouncingThunderclapAbilityHandler);
exports.BamsBouncingThunderclapAbilityHandler = BamsBouncingThunderclapAbilityHandler;
